module.exports = __webpack_public_path__ + "static/img/17_線上購物.7bd91a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/button/17_線上購物.png
// module id = JV2X
// module chunks = 1